module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"@root #home #storeList #storeList":{"baseRowNumber":[{"value":9,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107005},"path":"@root #home #storeList #storeList","_fox_":1}]},"@root #home #storeList #storeList #storeDl":{"limit":[{"value":27,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107007},"path":"@root #home #storeList #storeList #storeDl","_fox_":1}]},"@root #home #storeList #storeList #productList #list":{"hooks.onRendering":[{"value":function () {
var obj;
var rowNum = this.wom1('@parent @parent').getOption('baseRowNumber');
var createDiv = function () {
var div = document.createElement('div');
return div;
};
this.fragment = this.createFragment();
this.dl.getCollection().reduce(function (parts, cur, idx) {
var part = parts[parts.length - 1];
if (idx % rowNum !== 0) {
part.push(cur);
} else {
parts.push([cur]);
}
return parts;
}.bind(this), []).forEach(function (part) {
var block = createDiv();
part.forEach(function (obj) {
var tplRow = this.getOption('tpl.row');
var row = this.getTemplater(tplRow).setData([obj]).compile();
block.appendChild(row);
}, this)
this.fragment.appendChild(block);
}, this);
return true;
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107036},"path":"@root #home #storeList #storeList #productList #list","_fox_":1}]},"@root #home #storeList #storeCategories #selectCategories":{"selectIconClass":[{"value":"inf-icon_collections_19 ","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107040},"path":"@root #home #storeList #storeCategories #selectCategories","_fox_":1}],"selectArrClass":[{"value":"inf-icon_dropArrD_5","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107041},"path":"@root #home #storeList #storeCategories #selectCategories","_fox_":1}]},"@root #home #purchasesList #purchasesList":{"baseRowNumber":[{"value":9,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107044},"path":"@root #home #purchasesList #purchasesList","_fox_":1}]},"@root #home #purchasesList #purchasesList #storeDl":{"limit":[{"value":27,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107046},"path":"@root #home #purchasesList #purchasesList #storeDl","_fox_":1}]},"@root #home #purchasesList #purchasesList #purchasesList #list":{"hooks.onRendering":[{"value":function () {
var collection = this.dl.getCollection();
if (fox.isEmpty(collection)) {
emptyRow = this.getTemplater(this.getOption('tpl.emptyRow'));
this.fragment = emptyRow.compile();
return true;
}
var obj;
var rowNum = this.wom1('@parent @parent').getOption('baseRowNumber');
var createDiv = function () {
var div = document.createElement('div');
return div;
};
this.fragment = this.createFragment();
collection.reduce(function (parts, cur, idx) {
var part = parts[parts.length - 1];
if (idx % rowNum !== 0) {
part.push(cur);
} else {
parts.push([cur]);
}
return parts;
}.bind(this), []).forEach(function (part) {
var block = createDiv();
part.forEach(function (obj) {
var tplRow = this.getOption('tpl.row');
var row = this.getTemplater(tplRow).setData([obj]).compile();
block.appendChild(row);
}, this)
this.fragment.appendChild(block);
}, this);
return true;
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107081},"path":"@root #home #purchasesList #purchasesList #purchasesList #list","_fox_":1}]},"@root #home #storeItem #storeItem #storeDlRelated":{"limit":[{"value":9,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":1107086},"path":"@root #home #storeItem #storeItem #storeDlRelated","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ./components/store/options/store.js
// module id = 513
// module chunks = 4